import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';

export const SUBMIT_ANOTHER_CODE_ANALYTICS = {
    category: CATEGORY.ACTION,
};
